/** Namespace `mailStatus` — bản gốc tiếng Việt (PLAT-2026-117). Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const mailStatus = {
  title: "Vận hành email",
  subtitle:
    "Hub hỏi thẳng máy chủ từng app (ký HMAC, không qua trình duyệt): gửi bằng gì, nhà cung cấp còn nhận không, thư thật có đi không.",
  loadFailed: "Không đọc được trạng thái mail.",
  loading: "Đang hỏi các app…",
  refresh: "Hỏi lại",
  checkedAt: "Hỏi lúc {at}",
  summary: "{ready} sẵn sàng · {degraded} suy giảm · {down} hỏng · {unknown} chưa đo được · {total} app",
  "col.app": "App",
  "col.state": "Trạng thái",
  "col.provider": "Gửi bằng",
  "col.sender": "Domain gửi",
  "col.verify": "Nhà cung cấp",
  "col.critical": "Thư quan trọng · 1 giờ",
  "col.queue": "Hàng chờ",
  "col.reasons": "Lý do",
  "state.ready": "Sẵn sàng",
  "state.degraded": "Suy giảm",
  "state.down": "Hỏng",
  "outcome.not_configured": "Hub chưa cấu hình",
  "outcome.not_wired": "Chưa ốp chuẩn",
  "outcome.unauthorized": "Sai chữ ký",
  "outcome.unreachable": "Không gọi được",
  "outcome.invalid_response": "Sai hợp đồng",
  "hint.not_configured": "Hub thiếu URL hoặc secret đọc của app.",
  "hint.not_wired": "App chưa ốp chuẩn mail-status (404).",
  "hint.unauthorized": "App từ chối chữ ký — secret hai bên không khớp, hoặc đồng hồ lệch quá 5 phút.",
  "hint.unreachable": "Không gọi được app (mạng, lỗi 5xx hoặc quá 10 giây).",
  "hint.invalid_response": "Trả lời không khớp hợp đồng — hai bên lệch phiên bản kit.",
  "reason.STUB_IN_PRODUCTION": "Production chạy stub — không thư nào được gửi",
  "reason.FELL_BACK_TO_STUB": "Khai nhà cung cấp thật nhưng thiếu cấu hình nên chạy stub",
  "reason.STUB_OUTSIDE_PRODUCTION": "Chạy stub (ngoài production)",
  "reason.TRANSPORT_PROBLEM": "Cấu hình mail còn thiếu",
  "reason.PROVIDER_REJECTED_KEY": "Nhà cung cấp từ chối khoá API",
  "reason.SENDER_DOMAIN_NOT_VERIFIED": "Domain gửi chưa xác minh",
  "reason.PROVIDER_UNREACHABLE": "Không gọi được nhà cung cấp",
  "reason.CRITICAL_MAIL_FAILING": "Thư {kind} bỏ cuộc trong 1 giờ",
  "reason.CRITICAL_MAIL_RETRYING": "Thư {kind} đang chờ thử lại",
  "reason.MAIL_FAILING": "Thư {kind} hỏng nhiều trong 1 giờ",
  "reason.QUEUE_STALLED": "Hàng chờ thư bị kẹt",
  "reason.NOT_COUNTED": "App không đếm lượt gửi",
  declaredDiffers: "khai {declared}",
  "verify.ok": "Khoá đúng · domain đã xác minh",
  "verify.key_ok": "Khoá đúng (chỉ quyền gửi)",
  "verify.invalid_key": "Từ chối khoá",
  "verify.domain_unverified": "Domain chưa xác minh",
  "verify.domain_missing": "Domain không có trong tài khoản",
  "verify.unreachable": "Không gọi được",
  "verify.unsupported": "Chưa có phép kiểm",
  "verify.skipped": "Không kiểm",
  criticalCounts: "{sent} đi · {failed} hỏng",
  criticalNone: "chưa gửi",
  queueEmpty: "rỗng",
  queueStalled: "kẹt {minutes} phút",
  notCounted: "không đếm",
  noReasons: "—",
  "col.route": "Tuyến gửi",
  "source.hub": "Theo bube-hq · bản {version}",
  "source.env": "Theo env của app (chưa chuyển)",
  "source.none": "Chưa có tuyến",
  "source.unknown": "—",
  chooseRoute: "Chọn bộ email",
  // PLAT-2026-135 lát E — hub tự biết nó có tuyến cho app không (không cần app trả lời).
  "hubRoute.assigned": "Hub đã gán: {partner}",
  "hubRoute.not_applicable": "Hub không quản tuyến mail của app này",
  "hubRoute.no_binding": "Hub chưa gán bộ email cho app",
  "hubRoute.catalog_disallowed": "Hub: nhà cung cấp {partner} không còn mở cho app",
  "hubRoute.grandfathered_only": "Hub: chỉ có gán cũ chưa chạy thử ({partner})",
  "hubRoute.set_missing": "Hub: bộ thông số đã gán không còn ({partner})",
  "hubRoute.set_incomplete": "Hub: bộ thông số thiếu trường bắt buộc ({partner})",
  "hubRoute.decrypt_failed": "Hub không giải mã được khoá của bộ ({partner})",
  "hubRoute.from_missing": "Hub: bộ thông số thiếu địa chỉ gửi ({partner})",
  "test.open": "Gửi thử",
  "test.placeholder": "địa chỉ nhận thư thử",
  "test.send": "Gửi",
  "test.cancel": "Huỷ",
  "test.sending": "Đang gửi…",
  "test.sent": "Đã gửi qua {provider} — kiểm hộp thư.",
  "test.not_sent": "App không gửi được: {detail}",
  "test.rate_limited": "App đã gửi đủ 5 thư thử trong giờ này.",
  "test.not_configured": "Hub chưa có URL hoặc secret của app.",
  "test.not_wired": "App chưa ốp « Gửi thử ».",
  "test.unauthorized": "App từ chối chữ ký.",
  "test.unreachable": "Không gọi được app.",
  "test.invalid_response": "App trả lời sai hợp đồng.",
  "test.failed": "Gửi thử hỏng.",
  "test.store_unavailable": "App không ghi được lượt kiểm vào CSDL nên KHÔNG gửi — thử lại sau.",
  "test.code.CHALLENGE_EXPIRED": "lượt gửi thử đã hết hạn trước khi tới app (lệch giờ hai máy?)",
  "test.code.CHALLENGE_TTL_TOO_LONG": "lượt gửi thử có hạn quá 10 phút",
  "test.code.CHALLENGE_WRONG_CONSUMER": "lượt gửi thử dành cho app khác",
  "test.code.ROUTE_NOT_FOUND": "app không có tuyến được yêu cầu",
  "test.code.ROUTE_NOT_USABLE": "tuyến được yêu cầu thiếu thông số",
  "test.code.NO_ACTIVE_ROUTE": "app chưa có tuyến gửi mail nào dùng được (đang chạy stub)",
  "test.code.CHALLENGE_CONSUMED": "lượt gửi thử này đã được dùng",
  routeHint: "Tuyến gửi của mỗi app = bộ thông số email ĐANG BẬT ở Tích hợp (Resend · Elastic Email · Amazon SES). Đổi bộ là app dùng ngay, không cần deploy.",
  // PLAT-2026-135 lát I — trang « Mail của một app » (`/system/mail/:app`).
  "app.back": "← Mọi app",
  "app.title": "Mail · {name}",
  "app.subtitle": "Trạng thái hỏi sống lúc mở trang; số và thư lấy từ log lần gửi hub chép từ app (5 phút một lần).",
  "app.loading": "Đang đọc…",
  "app.loadFailed": "Không đọc được mail của app.",
  "app.open": "Chi tiết",
  "app.cursor": "Hub đã chép log lần gửi tới seq {seq}",
  "app.cursorNone": "Hub chưa chép log lần gửi nào của app",
  "app.gap": "Hub đã LỠ log lần gửi seq {from}–{to} (phát hiện {at}) — app dọn log sau 30 ngày trước khi hub kịp chép.",
  "app.logReset": "Log lần gửi của app đã ĐẶT LẠI (CSDL mới hoặc khôi phục bản sao lưu) — hub kéo lại từ đầu từ {at} (kỷ nguyên log {epoch}).",
  "app.logResetFrom":
    "Log lần gửi của app đã ĐẶT LẠI (CSDL mới hoặc khôi phục bản sao lưu) — hub kéo lại từ đầu từ {at} (kỷ nguyên log {epoch}). Thư gửi sau seq {seq} của log cũ mà hub chưa chép thì không còn thấy được.",
  "app.section.route": "Tuyến gửi",
  "app.section.problems": "Thiếu / sai gì",
  "app.section.counts": "Thư 24 giờ qua",
  "app.section.mails": "Thư",
  "app.section.lifecycle": "Vòng đời thư",
  "app.section.history": "Lịch sử sẵn sàng",
  "app.route.source.hub": "Theo bube-hq",
  "app.route.source.hub_lkg": "Theo bube-hq — bản hợp lệ gần nhất",
  "app.route.source.legacy": "Theo env cũ của app (giai đoạn chuyển)",
  "app.route.source.stub": "Không có tuyến — thư không đi",
  "app.route.applied": "App đã áp dụng bộ tuyến v{version}",
  "app.route.appliedNone": "App chưa nhận bộ tuyến nào từ hub",
  "app.route.stale": "Bản hub đẩy mới nhất hỏng — app chạy bằng bộ hợp lệ gần nhất từ {at}",
  "app.route.provider": "Gửi bằng {provider} · domain {domain}",
  "app.route.active": "Tuyến đang dùng: {route}",
  "app.route.latch": "Đã tự chuyển tuyến {from} ⇒ {to} lúc {at} (lần chuyển {switchId})",
  "app.route.latchNotDurable": "Lần chuyển chỉ giữ trong tiến trình — app không ghi được chốt vào CSDL",
  "app.route.degraded": "App không ghi được bảng lần gửi từ {since} ({reason}) — thư vẫn đi, hub có thể thiếu số",
  "app.problems.none": "Không thiếu gì",
  "problem.PROVIDER_NOT_SET": "Chưa khai nhà cung cấp",
  "problem.PROVIDER_UNKNOWN": "Nhà cung cấp lạ",
  "problem.API_KEY_MISSING": "Thiếu khoá / thông số đăng nhập",
  "problem.FROM_MISSING": "Thiếu địa chỉ gửi",
  "problem.FROM_INVALID": "Địa chỉ gửi sai định dạng",
  "problem.ROUTE_CONFIG_INVALID": "Cấu hình tuyến sai dạng — app không đọc được",
  "app.problems.field": "trường {field}",
  "app.problems.route": "tuyến {route}",
  "app.counts.empty": "Chưa có thư nghiệp vụ nào trong 24 giờ.",
  "app.col.kind": "Loại",
  "app.col.status": "Kết quả",
  "app.col.count": "Thư",
  "app.col.mail": "Thư",
  "app.col.attempts": "Lần gửi",
  "app.col.provider": "Nhà cung cấp",
  "app.col.error": "Lỗi",
  "app.col.last": "Lần cuối",
  "app.filter.failed": "Chỉ thư hỏng",
  "app.filter.all": "Mọi thư",
  "app.filter.anyKind": "Mọi loại",
  "app.filter.code": "Mã lỗi",
  "app.range.1": "24 giờ qua",
  "app.range.7": "7 ngày qua",
  "app.range.30": "30 ngày qua",
  "app.filter.apply": "Lọc",
  "app.mails.empty": "Không có thư nào khớp bộ lọc.",
  "app.lifecycle.hint": "Chọn một thư ở bảng trên để xem mọi lần gửi của nó.",
  "app.lifecycle.empty": "Hub chưa chép event nào của thư này.",
  "app.lifecycle.attempt": "Lần {n}",
  "app.lifecycle.failover": "chuyển từ tuyến {from} · {reason}",
  "app.lifecycle.newRequest": "ý định gửi mới {id}",
  "app.lifecycle.provider": "Phía nhà cung cấp (sự kiện giao thư)",
  "app.lifecycle.close": "Đóng",
  "app.history.empty": "Chưa có mẫu nào trong khoảng này.",
  "app.history.summary": "Mẫu: {ready} sẵn sàng · {degraded} suy giảm · {down} hỏng · {other} không đo được",
  "app.history.changes": "Lần đổi trạng thái",
  "status.started": "đang gửi",
  "status.accepted": "đã nhận",
  "status.rejected": "bị từ chối",
  "status.unknown": "không rõ kết quả",
  "status.stubbed": "không có tuyến",
  "purpose.validation": "thư kiểm",
  "kind.otp": "OTP",
  "kind.verify_email": "xác minh email",
  "kind.password_reset": "đặt lại mật khẩu",
  "kind.invite": "lời mời",
  "kind.login_notice": "báo đăng nhập",
  "kind.welcome": "chào mừng",
  "kind.approval": "duyệt",
  "kind.support": "hỗ trợ",
  "kind.receipt": "biên nhận",
  "kind.system": "hệ thống",
  "kind.other": "khác",
  "kind.notice": "thông báo",
  "kind.lifecycle": "vòng đời",
} as const;
